module.exports = __webpack_public_path__ + "e33b6ebc346993a6009e438d73ef26a6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon-MODELO-40px-x-40px.png
// module id = 369
// module chunks = 7